import { teamCanSeeEntity } from '../../domain/entity/entityVision.js';

function snapshotTeamVisionPayload(getPlayer, getAlliedViewers, getWallBoxes, matchRuntime) {
  const p = typeof getPlayer === 'function' ? getPlayer() : null;
  if (!p) return { omitted: false, visionRadius: null };
  const extras = typeof getAlliedViewers === 'function' ? getAlliedViewers() : [];
  const wallBoxes = typeof getWallBoxes === 'function' ? getWallBoxes() : [];
  const radius = Number(p.visionRadius) || 0;
  const far = {
    id: 'far-enemy',
    team: p.team === 'blue' ? 'red' : 'blue',
    x: (p.x || 0) + 4000,
    z: p.z ?? p.y ?? 0,
    isDead: false
  };
  const seen = teamCanSeeEntity(
    p.team || 'blue',
    far,
    [{ ...p, visionRadius: radius }, ...(extras || [])],
    [],
    matchRuntime?.activeWards || [],
    wallBoxes || []
  );
  return { omitted: !seen, visionRadius: radius };
}

/**
 * Agent smoke: snapshot-shaped team vision omit (FID-NET-01).
 */
export function attachSnapshotTeamVisionHook(win, deps = {}) {
  if (!win) return;
  win.__debugSnapshotTeamVision = () => snapshotTeamVisionPayload(
    deps.getPlayer,
    deps.getAlliedViewers,
    deps.getWallBoxes,
    deps.matchRuntime
  );
}
